var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 182,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#notice_svg__filter0_ii_4152_31604)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.925,
    y: 56.492,
    width: 108.049,
    height: 91.768,
    rx: 1.48,
    transform: "rotate(-15 66.925 56.492)",
    fill: "#F5F7FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#notice_svg__filter1_bd_4152_31604)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.212,
    y: 57.21,
    width: 124.33,
    height: 84.367,
    rx: 1.48,
    transform: "rotate(-15 24.212 57.21)",
    fill: "#fff",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.118,
    y: 57.733,
    width: 122.85,
    height: 82.887,
    rx: 0.74,
    transform: "rotate(-15 25.118 57.733)",
    stroke: "#fff",
    strokeWidth: 1.48
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    d: "M26.025 58.257l117.234-31.413 3.831 14.297L29.856 72.554z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222B40",
    d: "M34.03 62.398l7.772-2.082.44 1.644-7.772 2.082zM46.672 58.854l7.772-2.083.443 1.655-7.772 2.083z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F9",
    d: "M41.07 88.672l14.297-3.83 3.83 14.296-14.296 3.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    d: "M67.52 81.585l14.296-3.83 3.83 14.296-14.296 3.83zM93.968 74.498l14.297-3.83 3.83 14.296-14.296 3.83zM48.007 114.56l14.297-3.83 3.83 14.296-14.296 3.83zM74.456 107.473l14.297-3.83 3.83 14.296-14.296 3.83z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#notice_svg__filter2_b_4152_31604)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.17,
    d: "M122.967 79.784l80.063-21.453 17.239 64.337-80.063 21.452z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.22,
    d: "M124.326 80.569l77.918-20.878 16.665 62.191-77.919 20.878z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#notice_svg__filter3_dii_4152_31604)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.368,
    y: 67.554,
    width: 42.184,
    height: 42.184,
    rx: 21.092,
    transform: "rotate(-15 103.368 67.554)",
    fill: "url(#notice_svg__paint0_radial_4152_31604)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.167 87.333h1.666V89h-16.666v-1.667h1.666v-5a6.668 6.668 0 0113.334 0v5zm-1.667 0v-5a5.002 5.002 0 00-5-5 5.002 5.002 0 00-5 5v5h10zm-7.5 3.334h5v1.666h-5v-1.666z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "notice_svg__filter0_ii_4152_31604",
    x: 62.817,
    y: 24.419,
    width: 134.854,
    height: 123.342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96,
    dy: 2.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.76105 0 0 0 0 0.79122 0 0 0 0 0.838807 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4152_31604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.44,
    dy: -4.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4152_31604",
    result: "effect2_innerShadow_4152_31604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notice_svg__filter1_bd_4152_31604",
    x: 6.783,
    y: 5.382,
    width: 200.47,
    height: 172.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4152_31604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.841,
    dy: 9.621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_4152_31604",
    result: "effect2_dropShadow_4152_31604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4152_31604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notice_svg__filter2_b_4152_31604",
    x: 109.646,
    y: 45.01,
    width: 123.944,
    height: 112.431,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.661
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4152_31604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4152_31604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "notice_svg__filter3_dii_4152_31604",
    x: 68.14,
    y: 21.407,
    width: 132.481,
    height: 132.481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.18,
    dy: 5.18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.572
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.890226 0 0 0 0 0.267095 0 0 0 0 0.36016 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4152_31604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4152_31604",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.74,
    dy: -0.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.468975 0 0 0 0 0.0434092 0 0 0 0 0.107383 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_4152_31604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.74,
    dy: 0.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.961501 0 0 0 0 0.961501 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_innerShadow_4152_31604",
    result: "effect3_innerShadow_4152_31604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "notice_svg__paint0_radial_4152_31604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.73304 52.41733 -50.60816 10.3626 121.964 83.279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#E34C62"
  })))));
}
export default SvgNotice;